import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import SydLabel, { hookFormErrorAdapter } from '../../../../commonDesign/SydLabel'
import SydInput from '../../../../commonDesign/SydInput'
import SydButton from '../../../../commonDesign/Button'
import { modalStyles } from './brandModalStyles'
import { isValidUrl } from './utils'

export const ImageUrlField = ({ name, label, form, onAddImage, onSelectImage }) => {
  const classes = modalStyles()
  return (
    <div className={classes.inputRow}>
      <Controller
        name={name}
        control={form.control}
        rules={{
          required: { value: true, message: `${label} is required` },
          validate: isValidUrl
        }}
        render={({ field, fieldState }) => (
          <SydLabel label={label} error={hookFormErrorAdapter(form, fieldState)} className={classes.formLabel}>
            <SydInput {...field} error={fieldState.error} />
            <div className={classes.buttonRowInput}>
              <SydButton
                variant='outline'
                size='md'
                onClick={() => onAddImage(field.name)}
                icon='image'
              >
                Add Image
              </SydButton>
              <SydButton
                variant='outline'
                size='md'
                onClick={() => onSelectImage(field.name)}
                icon='image'
              >
                Select Image
              </SydButton>
            </div>
          </SydLabel>
        )}
      />
    </div>
  )
}

ImageUrlField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  form: PropTypes.object.isRequired,
  onAddImage: PropTypes.func.isRequired,
  onSelectImage: PropTypes.func.isRequired
}

export default ImageUrlField
